<div class="query">
    <nz-spin class="query-spin" [nzSpinning]="queryLoading" nzSize="large">
    <div class="query-main">
        <nz-splitter (nzResizeEnd)="onSplitResizeEnd('horizontal', $event, null)">
            <nz-splitter-panel *ngIf="showObject" [nzDefaultSize]="leftDivHor + '%'" nzMin="15%">
                <div class="query-object-view">
                    <nz-tabs>
                        <nz-tab [nzTitle]="'QUERY_EXECUTOR.LABEL.TABLE'|translateTA">
                            <div class="query-object-item-list">
                                <nz-input-group [nzPrefix]="searchIcon" class="full-width">
                                    <input nz-input type="text" #valueInputTable [placeholder]="'QUERY_EXECUTOR.PLACEHOLDER.FINDOBJECT'|translateTA" />
                                </nz-input-group>
                                <nz-divider class="hdivider"></nz-divider>
                                <div class="query-object-item-list-view">
                                    <div class="object-list">
                                        <div class="object-name" *ngFor="let item of objects|arrayFilter:'TYPE':'TABLES':false:true:{field:'INSTANCENAME',value:valueInputTable.value}"
                                            (click)="selectObject(item,'TABLES')" [ngClass]="{'object-inactive': item['ACTIVE']=='0'}">
                                            {{item.INSTANCENAME}} - {{item.INSTANCEDESC}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </nz-tab>
                        <nz-tab [nzTitle]="'QUERY_EXECUTOR.LABEL.VIEWS'|translateTA">
                            <div class="query-object-item-list">
                                <nz-input-group [nzPrefix]="searchIcon" class="full-width">
                                    <input nz-input type="text" #valueInputView [placeholder]="'QUERY_EXECUTOR.PLACEHOLDER.FINDOBJECT'|translateTA" />
                                </nz-input-group>
                                <nz-divider class="hdivider"></nz-divider>
                                <div class="query-object-item-list-view">
                                    <div class="object-list">
                                        <div class="object-name" *ngFor="let item of objects|arrayFilter:'TYPE':'VIEW':false:true:{field:'INSTANCENAME',value:valueInputView.value}"
                                            (click)="selectObject(item)" [ngClass]="{'object-inactive': item['ACTIVE']=='0'}">
                                            {{item.INSTANCENAME}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </nz-tab>
                        <nz-tab [nzTitle]="'QUERY_EXECUTOR.LABEL.FUNCTIONS'|translateTA">
                            <div class="query-object-item-list">
                                <nz-input-group [nzPrefix]="searchIcon" class="full-width">
                                    <input nz-input type="text" #valueInputFunction [placeholder]="'QUERY_EXECUTOR.PLACEHOLDER.FINDOBJECT'|translateTA" />
                                </nz-input-group>
                                <nz-divider class="hdivider"></nz-divider>
                                <div class="query-object-item-list-view">
                                    <div class="object-list">
                                        <div class="object-name" *ngFor="let item of objects|arrayFilter:'TYPE':'FUNCTIONS':false:true:{field:'INSTANCENAME',value:valueInputFunction.value}"
                                            (click)="selectObject(item)" [ngClass]="{'object-inactive': item['ACTIVE']=='0'}">
                                            {{item.INSTANCENAME}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </nz-tab>
                        <nz-tab [nzTitle]="'QUERY_EXECUTOR.LABEL.PROCEDURES'|translateTA">
                            <div class="query-object-item-list">
                                <nz-input-group [nzPrefix]="searchIcon" class="full-width">
                                    <input nz-input type="text" #valueInputProcedure [placeholder]="'QUERY_EXECUTOR.PLACEHOLDER.FINDOBJECT'|translateTA" />
                                </nz-input-group>
                                <nz-divider class="hdivider"></nz-divider>
                                <div class="query-object-item-list-view">
                                    <div class="object-list">
                                        <div class="object-name" *ngFor="let item of objects|arrayFilter:'TYPE':'PROCEDURE':false:true:{field:'INSTANCENAME',value:valueInputProcedure.value}"
                                            (click)="selectObject(item)" [ngClass]="{'object-inactive': item['ACTIVE']=='0'}">
                                            {{item.INSTANCENAME}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </nz-tab>
                        <nz-tab [nzTitle]="'QUERY_EXECUTOR.LABEL.TRIGGERS'|translateTA">
                            <div class="query-object-item-list">
                                <nz-input-group [nzPrefix]="searchIcon" class="full-width">
                                    <input nz-input type="text" #valueInputTrigger [placeholder]="'QUERY_EXECUTOR.PLACEHOLDER.FINDOBJECT'|translateTA" />
                                </nz-input-group>
                                <nz-divider class="hdivider"></nz-divider>
                                <div class="query-object-item-list-view">
                                    <div class="object-list">
                                        <div class="object-name" *ngFor="let item of objects|arrayFilter:'TYPE':'TRIGGERS':false:true:{field:'INSTANCENAME',value:valueInputTrigger.value}"
                                            (click)="selectObject(item)" [ngClass]="{'object-inactive': item['ACTIVE']=='0'}">
                                            {{item.INSTANCENAME}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </nz-tab>
                    </nz-tabs>
                    <ng-template #searchIcon><nz-icon nzType="search"></nz-icon></ng-template>
                </div>
            </nz-splitter-panel>
            <nz-splitter-panel>
                <div class="query-view">
                    <div class="query-toolbar">
                        <button nz-button nzType="primary" nzShape="circle" [disabled]="disableTab()" *ngIf="testMode" (click)="executeQueryTestMode()" nz-tooltip="Executar">
                            <nz-icon nzType="caret-right"></nz-icon>
                        </button>
                        <button nz-button nzType="primary" nzShape="circle" nz-dropdown [nzDropdownMenu]="menuExec" [disabled]="disableTab()" *ngIf="!testMode" nz-tooltip="Executar">
                            <nz-icon nzType="caret-right"></nz-icon>
                        </button>
                        <nz-dropdown-menu #menuExec="nzDropdownMenu">
                            <ul nz-menu>
                                <li nz-menu-item (click)="executeQuery(getCurrentItem(),'sqlserver',null,'sqlserver')">
                                    <generic-icon iconName="sqlserver" type="custom"></generic-icon>
                                    <span class="menu-label">{{ 'QUERY_EXECUTOR.BUTTON.SQL_SERVER' |translateTA }}</span>
                                </li>
                                <li nz-menu-divider *ngIf="showConnection"></li>
                                <ng-container *ngIf="showConnection">
                                    <li *ngFor="let btn of buttonAdd" nz-menu-item (click)="executeQuery(getCurrentItem(),btn.NAME,btn,btn.ICON)">
                                        <generic-icon [iconName]="btn.ICON" type="custom"></generic-icon>
                                        <span class="menu-label">{{btn.NAME|translateTA}}</span>
                                    </li>
                                </ng-container>
                            </ul>
                        </nz-dropdown-menu>
                        <button nz-button nzShape="circle" (click)="exportToExcel()" *ngIf="canExport && !testMode" [disabled]="disableTab()" nz-tooltip="Exportar Excel">
                            <generic-icon iconName="excel" type="custom"></generic-icon>
                        </button>
                        <button nz-button nzShape="circle" (click)="openConfiguration()" *ngIf="!testMode" nz-tooltip="Configurações">
                            <nz-icon nzType="setting"></nz-icon>
                        </button>
                        <div class="flex-spacer"></div>
                        <div class="messages">
                            <span class="message">{{ 'QUERY_EXECUTOR.MESSAGE.DISPLAY_LIMIT' |translateTA : {maxRows:maxRows} }}</span>
                        </div>
                    </div>
                    <div class="tabs-container">
                        <nz-tabs *ngIf="!testMode" [(nzSelectedIndex)]="selectedTabIndex" [nzTabBarExtraContent]="addTabTpl">
                            <nz-tab *ngFor="let item of tabs" [nzTitle]="tabTitleTpl">
                                <ng-template #tabTitleTpl>
                                    <div class="tab">
                                        <generic-icon [iconName]="item.icon" type="custom" *ngIf="item.icon!=null"></generic-icon>

                                        <div class="tab-name" *ngIf="item.type!='sqlserver_desc_object'">
                                            <div *ngIf="item.btnName!=null" class="tab-name-btn">{{item.btnName}}</div>
                                            <nz-divider nzType="vertical" *ngIf="item.btnName!=null"></nz-divider>
                                            <div>{{item.name}}</div>
                                        </div>
                                        <div class="tab-name" *ngIf="item.type=='sqlserver_desc_object'">
                                            <div *ngIf="item.btnName!=null" class="tab-name-btn">{{item.btnName}}</div>
                                        </div>

                                        <nz-icon class="fechar" nzType="close" (click)="closeTab(item.index);$event.stopPropagation()"></nz-icon>
                                    </div>
                                </ng-template>

                                <div class="query-text" *ngIf="item.type=='sqlserver_desc_object'">
                                    <div class="tem-field fill-container" [nz-tooltip]="'QUERY_EXECUTOR.MESSAGE.CONTROLE'|translateTA">
                                        <label class="tem-field-label">{{'QUERY_EXECUTOR.LABEL.OBJECTVIEW'|translateTA}}</label>
                                        <textarea nz-input [(ngModel)]="item.query" disabled class="fill-container object-view-text"></textarea>
                                    </div>
                                </div>

                                <nz-splitter  *ngIf="item.type!='sqlserver_desc_object'"
                                    nzLayout="vertical"
                                    (nzResizeEnd)="onSplitResizeEnd('vertical', $event, item)">

                                    <nz-splitter-panel [nzDefaultSize]="item.leftDivVer + '%'" nzMin="10%">
                                        <div class="query-text">
                                            <div class="tem-field fill-container" [nz-tooltip]="'QUERY_EXECUTOR.MESSAGE.CONTROLE'|translateTA">
                                                <label class="tem-field-label">{{'QUERY_EXECUTOR.LABEL.QUERY'|translateTA}}</label>
                                                <textarea nz-input required [(ngModel)]="item.query" (ngModelChange)="emitQueryEvent(item.query)" (keydown)="performAction($event,item)" class="fill-container query-text-area"></textarea>
                                            </div>
                                        </div>
                                    </nz-splitter-panel>
                                    <nz-splitter-panel nzMin="10%">
                                        <div class="query-result">
                                            <ag-grid-angular
                                                style="width: 100%; height: 100%"
                                                [class]="(ThemeService.theme)? 'ag-theme-quartz-dark':'ag-theme-quartz'"
                                                [rowData]="item.rows"
                                                (rowSelected)="selectedData($event)"
                                                [columnDefs]="item.displayedColumns"
                                                (gridReady)="onGridReady($event,item)"
                                                [localeText]="ls.getCurrentGridLocale()"
                                                overlayNoRowsTemplate   ="{{'NODATAFOUND'|translateTA}}"
                                                rowBuffer="150"
                                                [gridOptions]="gridOptions"
                                                rowSelection="multiple"
                                                cacheBlockSize= "100"
                                                cacheOverflowSize="2"
                                                maxBlocksInCache= 10
                                                [pagination]="true"
                                                [loadingOverlayComponent]="loadingOverlayComponent"
                                                [loadingOverlayComponentParams]="loadingOverlayComponentParams"
                                                [enableCellTextSelection]="true"
                                                [suppressClipboardPaste]="true"
                                                [multiSortKey]="true">
                                            </ag-grid-angular>
                                        </div>
                                    </nz-splitter-panel>
                                </nz-splitter>

                            </nz-tab>
                        </nz-tabs>
                        <ng-template #addTabTpl>
                            <button nz-button nzType="text" (click)="addNewTab($event)" nz-tooltip="Nova query">
                                <nz-icon nzType="plus"></nz-icon>
                            </button>
                        </ng-template>

                        <nz-splitter  *ngIf="testMode"
                                    nzLayout="vertical"
                                    (nzResizeEnd)="onSplitResizeEnd('vertical', $event, null)">

                            <nz-splitter-panel [nzDefaultSize]="leftDivVer + '%'" nzMin="10%">
                                    <div class="query-text">
                                        <div class="tem-field fill-container" [nz-tooltip]="'QUERY_EXECUTOR.MESSAGE.CONTROLE'|translateTA">
                                            <label class="tem-field-label">{{'QUERY_EXECUTOR.LABEL.QUERY'|translateTA}}</label>
                                            <textarea nz-input required [(ngModel)]="query" (ngModelChange)="emitQueryEvent(query)" (keydown)="performActionTestMode($event)" class="fill-container query-text-area"></textarea>
                                        </div>
                                    </div>
                            </nz-splitter-panel>
                            <nz-splitter-panel nzMin="10%">
                                    <div class="query-result">
                                        <ag-grid-angular
                                            style="width: 100%; height: 100%"
                                            [class]="(ThemeService.theme)? 'ag-theme-quartz-dark':'ag-theme-quartz'"
                                            [rowData]="rowsTestMode"
                                            [columnDefs]="displayedColumnsTestMode"
                                            (gridReady)="onGridReadyTestMode($event)"
                                            [localeText]="ls.getCurrentGridLocale()"
                                            overlayNoRowsTemplate   ="{{'NODATAFOUND'|translateTA}}"
                                            rowBuffer="150"
                                            [gridOptions]="gridOptions"
                                            rowSelection="multiple"
                                            cacheBlockSize= "100"
                                            cacheOverflowSize="2"
                                            maxBlocksInCache= 10
                                            [pagination]="true"
                                            [loadingOverlayComponent]="loadingOverlayComponent"
                                            [loadingOverlayComponentParams]="loadingOverlayComponentParams"
                                            [enableCellTextSelection]="true"
                                            [suppressClipboardPaste]="true"
                                            [multiSortKey]="true">
                                        </ag-grid-angular>
                                    </div>
                                </nz-splitter-panel>
                        </nz-splitter>
                    </div>
                </div>
            </nz-splitter-panel>
        </nz-splitter>
    </div>
    </nz-spin>

    <div class="action-image-buttons" *ngIf="popup">
        <actions-buttons [buttonList]="buttonList" [data]="tabs[0].query"></actions-buttons>
    </div>
</div>
